<template>
  <div class="profile-page">
    <!-- Header Background -->
    <div class="header-bg"></div>

    <!-- Profile Card -->
    <div class="profile-card">
      <img :src="profileImgSrc" alt="avatar" class="avatar"/>
<h2 class="name">{{ userProfile && userProfile.first_name }} {{ userProfile && userProfile.last_name }}</h2>

      <!-- Tabs -->
      <div class="tabs">
        <button 
          :class="{ active: currentTab === 'ProfileData' }" 
          @click="currentTab = 'ProfileData'"
        >
          بياناتي
        </button>
        <button 
          :class="{ active: currentTab === 'MonthlyAchivement' }" 
          @click="currentTab = 'MonthlyAchivement'"
        >
          إنجازاتي
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="content">
      <component :is="currentTab" />
    </div>

    <!-- Floating Logout -->
    <button class="logout-btn" @click="showLogoutModal = true">
      <i class="bi bi-door-open"></i>
    </button>

    <!-- Logout Modal -->
    <CustomModal
      :visible="showLogoutModal"
      title="تأكيد تسجيل الخروج"
      message="هل أنت متأكدة من تسجيل الخروج؟"
      :showCancel="true"
      confirmText="نعم"
      cancelText="إلغاء"
      @confirm="performLogout"
      @cancel="showLogoutModal = false"
      @close="showLogoutModal = false"
    />
  </div>
</template>

<script>
import ProfileData from '@/components/ProfileData.vue'
import MonthlyAchivement from '@/components/MonthlyAchivement.vue'
import CustomModal from '@/components/CustomModal.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { ProfileData, MonthlyAchivement, CustomModal },
  data() {
    return {
      currentTab: 'ProfileData',
      showLogoutModal: false,
      profileImgSrc: require('@/assets/images/profile.png')
    }
  },
    computed: {
    ...mapGetters(['userProfile'])
  },
  methods: {
    ...mapActions(['logout']),
    async performLogout() {
      try {
        await this.logout()
        console.log("تم تسجيل الخروج من السيرفر")
      } catch (err) {
        console.log("خطأ أثناء تسجيل الخروج:", err)
      } finally {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
/* Page */
.profile-page {
  min-height: 100vh;
  background: #f9fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Cairo', sans-serif;
  padding: 2rem 1rem;
  position: relative;
}

/* Header Gradient */
.header-bg {
  width: 100%;
  height: 260px;
  background: linear-gradient(135deg, #FF9A18, #FFB74D);
  border-radius: 0 0 40px 40px;
  position: absolute;
  top: 0;
  left: 0;
}

/* Profile Card */
.profile-card {
  background: #fff;
  padding: 2rem;
  border-radius: 24px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.05);
  margin-top: 170px;
  text-align: center;
  width: 100%;
  max-width: 500px;
  position: relative;
  z-index: 1;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-top: -80px;
  border: 4px solid #fff;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.name {
  font-size: 22px;
  font-weight: bold;
  margin: 0.5rem 0;
  text-align: center;
}

.email {
  color: #666;
  font-size: 14px;
  margin-bottom: 1rem;
}

/* Tabs */
.tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.tabs button {
  padding: 0.6rem 1.2rem;
  border-radius: 12px;
  border: none;
  background: #f3f4f6;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s;
}

.tabs button.active {
  background: #FF9A18;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(59,130,246,0.3);
}

/* Content */
.content {
  width: 100%;
  max-width: 1000px;
  margin-top: 2rem;
}

/* Floating Logout */
.logout-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #ef4444;
  border: none;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  color: #fff;
  font-size: 25px;
  box-shadow: 0 6px 15px rgba(239,68,68,0.4);
  cursor: pointer;
  transition: 0.3s;
}

.logout-btn:hover {
  background: #dc2626;
}
</style>
